import React, {useState} from "react";
import {inject, observer} from "mobx-react";
import {useNavigate} from "react-router-dom";
// local
import {OrganizationCard} from "components/organizationCard/OrganizationCard";
import {Preloader} from "components/Preloader";
import OrganizationCardHead from "components/organizationCard/OrganizationCardHead";
import SubscriptionUpgrageLocalModal from "components/modals/SubscriptionUpgrageLocalModal";
import {hasPermission, getUrlParams} from "helpers/helper";
import EmptyData from "components/EmptyData";
import {PaginationType} from "components/Pagination";
import HandyPointerBlob from "components/HandyPointerBlob";

const FavoritesSection = inject("store")(
  observer(({store: {organization}, onChangeSort}) => {
    const {
      filterParams,
      suppliers: {totalItems, currentPage, searchPreferences},
      loading,
    } = organization;
    const navigate = useNavigate();

    const [isHistory, setShowHistory] = useState(false);

    const SubscriptionUpgrageLocalModalPermissions = [
      "READ_TABLE_CREDIT_RATING",
      "READ_TABLE_TURNOVER",
      "READ_TABLE_COLLECTIVE_UNION_AGREEMENTS",
    ];

    const updateUrlParams = (search) => navigate({search});

    const handlePageChange = (pageNumber) => {
      organization.setFilterParams({...filterParams, page: pageNumber});
      updateUrlParams(getUrlParams(filterParams, {page: pageNumber}));
      organization.searchSuppliers();
    };

    return (
      <div className="our-suppliers__organizations-table">
        <HandyPointerBlob
          showPointer
          text="NEW_FEATURE_SEARCHFILTERS_TEXT"
          align="right"
          position={{top: "-9px", right: "32px"}}
        />
        <OrganizationCardHead
          onChangeSort={onChangeSort}
          isHistory={isHistory}
          onChangeShowHistory={() => setShowHistory(!isHistory)}
          showTotalItems
          filledFilters={Object.keys(filterParams).length > 1}
        />
        {loading && <Preloader addClass="preloader100" />}
        {!loading && (
          <React.Fragment>
            {!!searchPreferences?.length ? (
              searchPreferences.map((s) => {
                if (s.Organization) {
                  return (
                    <OrganizationCard
                      key={s.Organization.id}
                      organization={s.Organization}
                      isHistory={isHistory}
                      showTitleIcon
                      place="favorites"
                    />
                  );
                }
                return null;
              })
            ) : (
              <EmptyData />
            )}
          </React.Fragment>
        )}

        <PaginationType
          totalItems={totalItems}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          addClass="mt-8"
        />

        {!hasPermission(SubscriptionUpgrageLocalModalPermissions) &&
          !loading &&
          !!searchPreferences?.length && (
            <SubscriptionUpgrageLocalModal
              canPermissions={SubscriptionUpgrageLocalModalPermissions}
            />
          )}
      </div>
    );
  })
);

export default FavoritesSection;
